













import axios from "axios";
import { Component, Vue } from "vue-property-decorator";
import securityService from "./services/SecurityService";
import HeaderNavbar from "@/components/HeaderNavbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import AppFooter from "@/components/AppFooter.vue";

@Component({
  components: {
    HeaderNavbar,
    Sidebar,
    AppFooter
  }
})
export default class App extends Vue {
  authenticated: boolean = securityService.isAuth();

  created() {
    // Add a response interceptor
    axios.interceptors.response.use(
      (response: any) => {
        return response;
      },
      (error: any) => {
        if (error.response.status === 401) {
          securityService.removeAuthToken();
          this.updateAuthenticated();
          this.$router.push("/login");
        }

        return Promise.reject(error);
      }
    );
  }

  updateAuthenticated() {
    this.authenticated = securityService.isAuth();
  }
}
